document.addEventListener('DOMContentLoaded', function() {
    const pollBlocks = document.querySelectorAll('.poll');

    pollBlocks.forEach(block => {
        const pollButtons = block.querySelectorAll('.poll-btn');
        const commentField = block.querySelector('.poll-comment-field');
        const commentTextarea = block.querySelector('.poll-comment-textarea');
        const saveCommentBtn = block.querySelector('.poll-save-comment-btn');
        const changeResponseBtn = block.querySelector('.poll-change-response-btn');

        // Handle response button clicks
        if (pollButtons.length > 0) {
            pollButtons.forEach(button => {
                button.addEventListener('click', function(e) {
                    // mark button as selected
                    pollButtons.forEach(btn => btn.classList.remove('selected'));
                    this.classList.add('selected');

                    // store reference to button for timeout function
                    const btnReference = this;

                    // handle the response after delay to show the selection
                    setTimeout(() => handlepollResponse(btnReference), 200);
                });
            });
        }

        // Handle save comment button
        if (saveCommentBtn && commentTextarea) {
            saveCommentBtn.addEventListener('click', function(e) {
                e.preventDefault();
                handleSaveComment(commentTextarea);
            });
        }

        // response change
        if (changeResponseBtn) {
            changeResponseBtn.addEventListener('click', function() {
                const responseContainer = this.closest('.poll-user-response');
                const buttonContainer = block.querySelector('.poll-response-buttons');

                if (buttonContainer) {
                    // Hide response
                    responseContainer.style.display = 'none';

                    // Show buttons
                    buttonContainer.style.display = 'flex';

                    //select button that matches current response
                    const currentResponse = responseContainer.querySelector('strong').innerText.toLowerCase();
                    if (currentResponse === 'ja') {
                        buttonContainer.querySelector('.poll-yes-btn').classList.add('selected');
                    } else if (currentResponse === 'nei') {
                        buttonContainer.querySelector('.poll-no-btn').classList.add('selected');
                    }
                }
            });
        }
    });

    function handlepollResponse(button) {
        // check if button or an event
        const targetButton = button.currentTarget ? button.currentTarget : button;
        const postId = targetButton.getAttribute('data-post-id');
        const pollId = targetButton.getAttribute('data-poll-id');
        const response = targetButton.getAttribute('data-response');
        const pollBlock = targetButton.closest('.poll');
        const commentField = pollBlock.querySelector('.poll-comment-field');
        const commentTextarea = pollBlock.querySelector('.poll-comment-textarea');
        const pollResult = pollBlock.querySelector('.poll-result');

        console.log('Button:', targetButton);
        console.log('Post ID:', postId);
        console.log('poll ID:', pollId);
        console.log('Response:', response);

        if (!postId || !response) {
            console.error('Missing data attributes for poll response. Button:', targetButton);
            return;
        }

        // loading state
        const allButtons = targetButton.parentNode.querySelectorAll('button');
        allButtons.forEach(btn => {
            btn.disabled = true;
            btn.classList.add('processing');
        });

        // AJAX request
        const data = new FormData();
        data.append('action', 'poll_response');
        data.append('post_id', postId);
        data.append('poll_id', pollId);
        data.append('response', response);
        if (commentTextarea) {
            data.append('comment', commentTextarea.value);
        }
        data.append('security', feltpost_scripts.nonce);

        $.ajax({
            url: feltpost_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false,
            error: function(error) {
                console.error('Error submitting response', error);
                // re-enable buttons
                allButtons.forEach(btn => {
                    btn.disabled = false;
                    btn.classList.remove('processing');
                });
            },
            success: function(response) {
                if (!response.success) {
                    console.error('Error in response', response);
                    console.error('Error message:', response.data ? response.data.message : 'No message');
                    // Still re-enable buttons even on error
                    allButtons.forEach(btn => {
                        btn.disabled = false;
                        btn.classList.remove('processing');
                    });
                    return;
                }

                // Update button states based on response
                allButtons.forEach(btn => {
                    btn.disabled = false;
                    btn.classList.remove('processing');

                    // Set selected state based on server response
                    const buttonResponse = btn.getAttribute('data-response');
                    if (buttonResponse === response.data.response) {
                        btn.classList.add('selected');
                    } else {
                        btn.classList.remove('selected');
                    }
                });

                // Show comment field if it exists and user has responded
                console.log('Comment field:', commentField, 'Response:', response.data.response);
                if (commentField && response.data && response.data.response) {
                    console.log('Showing comment field');
                    commentField.style.display = 'block';
                }

                // Re-render display
                if (response.data.html) {
                    pollResult.innerHTML = response.data.html;
                }
            }
        });
    }
});